import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export interface BreadcrumbSegment {
  label: string
  href?: string
}

interface BreadcrumbProps {
  segments: BreadcrumbSegment[]
}

export function Breadcrumb({ segments }: BreadcrumbProps) {
  const { t } = useTranslation()
  return (
    <nav className="breadcrumb" aria-label={t('breadcrumb.ariaLabel')}>
      <ol className="breadcrumb-list">
        {segments.map((segment, index) => {
          const isLast = index === segments.length - 1
          return (
            <li key={index} className="breadcrumb-item">
              {!isLast && segment.href ? (
                <Link to={segment.href}>{segment.label}</Link>
              ) : (
                <span aria-current={isLast ? 'page' : undefined}>
                  {segment.label}
                </span>
              )}
              {!isLast && (
                <span className="breadcrumb-separator" aria-hidden="true">›</span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
